// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionE_comp__Ozh6C"};